import { getRootAddinUrl } from "../../../utils/browser";
import { applyRangeFormats, rangeFormatting } from "../../styles/worksheet";
import { rangeNames } from "../helpers/rangeNames";

export const titleMaker = async (sheet: Excel.Worksheet, title: string, type: string = "estimate") => {
  const rowHeights = [45, 30, 25, 25];
  rowHeights.forEach((height, index) => {
    sheet.getRange(`${index + 1}:${index + 1}`).format.rowHeight = height;
  });

  // Insert the logo as an image
  const baseUrl = getRootAddinUrl();
  const logoFormula = `=IFERROR(IMAGE("${baseUrl}/assets/ediphi_logo_wordmark.png",,3,40),"LOGO")`;
  sheet.getRange("B1").values = [[logoFormula]];
  sheet.getRange("B1:C1").merge();
  sheet.getRange("B1:C1").format.horizontalAlignment = "Left";

  // Create the title block — fall back to old Report/GCGR table names for unmigrated workbooks
  const projectReportTable = sheet.context.workbook.tables.getItemOrNullObject("ProjectReport");
  const estimateReportTable = sheet.context.workbook.tables.getItemOrNullObject("EstimateReport");
  const gcgrReportTable = sheet.context.workbook.tables.getItemOrNullObject("GCGRReport");
  await sheet.context.sync();
  const hasNewTables = !projectReportTable.isNullObject;
  const hasEstimateReport = !estimateReportTable.isNullObject;
  const hasGcgrReport = !gcgrReportTable.isNullObject;

  const projectNameFormula = hasNewTables ? "=ProjectReport[project_name]" : "=Report[project_name]";
  const estimateNameFormula = hasEstimateReport ? "=EstimateReport[estimate_name]" : "=Report[estimate_name]";
  const gcgrNameFormula = hasGcgrReport ? "=GCGRReport[gcgr_name]" : "=GCGR[name]";
  const typeVal = type === "gcgr" ? gcgrNameFormula : type === "estimate" ? estimateNameFormula : "Contracting";

  const titleRows: rangeFormatting[] = [
    { rangeAddress: "B1", value: logoFormula, fontSize: 24, bold: true },
    { rangeAddress: "B2", value: projectNameFormula, fontSize: 16, bold: true },
    { rangeAddress: "B3", value: typeVal, fontSize: 14, bold: true, italic: true },
    { rangeAddress: "B4", name: rangeNames.title, value: title, fontSize: 11, bold: true },
  ];
  applyRangeFormats(sheet, titleRows);
};
